import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button1, Button3 } from "../../Snippets/Button";
import SearchBar from "../../Snippets/TableCustomHooks/SearchBar";
import Loader from "../../Snippets/Loader";
import Table from "../../Snippets/TableCustomHooks/Table";
import Pagination from "../../Snippets/TableCustomHooks/Pagination";
import EmptyDataAlert from "../../Snippets/TableCustomHooks/EmptyDataAlert";
import ArbitrationAction from "./ArbitrationAction";
import { fetchArbitrationDetails ,  fetchScheduledArbitrations , fetchExpiredArbitrations,   addCommenceArbitration} from "../../../Services/ArbitrationManagement/ArbitrationData";
import { useDispatch } from "react-redux";
// import { addCommenceReducer } from "../../../Redux-reducer/ArbitrationManage";

const ArbitrationTable = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(true);
  const [userData, setUserData] = useState([]);
  const [isPreviewOpen, setPreviewOpen] = useState(false);
  const [pagination, setPagination] = useState({
  page: 1,
  totalPages: 1,
  hasNextPage: false,
  hasPrevPage: false,
});
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState();
  const [fetchLoading, setFetchLoading] = useState(false);
  const [operation, setOperation] = useState("add");
  const [arbitrationType, setArbitrationType] = useState("All Arbitration");
  const [page, setPage] = useState(1);
  const limit = 10;
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

const navigate = useNavigate();

 const handleSearch = (e) => {
  setSearchQuery(e.target.value);
  setPage(1);
};

const handleRowClick = (caseId) => {
  console.log("Clicked:", caseId);
  navigate(`/dashboard/case-details/${caseId}`);
};


const fetchArbitrationDetail = async () => {
  try {
    setIsLoading(true);

    let res;
    let docs = [];

    if (arbitrationType === "Scheduled Arbitration") {
      res = await fetchScheduledArbitrations({
        page,
        limit,
        cd_Case_ID: debouncedSearch,
      });

      docs = res?.response?.data || [];

    } else if (arbitrationType === "Expired Arbitration") {
      res = await fetchExpiredArbitrations({
        page,
        limit,
        cd_Case_ID: debouncedSearch,
      });

      docs = res?.response?.data || [];

    } else {
      res = await fetchArbitrationDetails({
        page,
        limit,
        cd_Case_ID: debouncedSearch,
      });

      docs = res?.response?.docs || [];
    }

    setUserData(Array.isArray(docs) ? docs : []);

    setPagination({
      totalPages: res?.response?.totalPages || 1,
      page: res?.response?.page || 1,
      hasNextPage: page < (res?.response?.totalPages || 1),
      hasPrevPage: page > 1,
    });

  } catch (error) {
    console.log("Fetch Error:", error);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearch(searchQuery);
    setPage(1);
  }, 500); // 500ms delay

  return () => clearTimeout(timer);
}, [searchQuery]);


useEffect(() => {
  fetchArbitrationDetail();
}, [page, arbitrationType, debouncedSearch]);


const handleOption = (value) => {
  setPage(1);

  switch (value) {
    case "all":
      setArbitrationType("All Arbitration");
      break;
    case "scheduled":
      setArbitrationType("Scheduled Arbitration");
      break;
    case "expired":
      setArbitrationType("Expired Arbitration");
      break;
    default:
      break;
  }
};

  const handleSubmit = async (values, uploadedFiles) => {
  try {

    const arbitrator_Details = [
      {
        arbitrator_name: values.arbitratorName,
        arbitrator_email: values.arbitratorEmail,
        arbitrator_mobile_number: values.arbitratorPhone,
        arbitrator_whatsapp: values.arbitratorWhatsapp,
        arbitrator_address: values.arbitratorAddress,
      },
      ...values.additionalArbitrators.map((arb) => ({
        arbitrator_name: arb.name,
        arbitrator_email: arb.email,
        arbitrator_mobile_number: arb.phone,
        arbitrator_whatsapp: arb.whatsapp,
        arbitrator_address: arb.address,
      })),
    ];

    const claimant_Details = [
      {
        claimant_name: values.claimantName,
        claimant_email: values.claimantEmail,
        claimant_mobile_number: values.claimantPhone,
        claimant_whatsapp: values.claimantWhatsapp,
        claimant_address: values.claimantAddress,
      },
      ...values.additionalClaimants.map((c) => ({
        claimant_name: c.name,
        claimant_email: c.email,
        claimant_mobile_number: c.phone,
        claimant_whatsapp: c.whatsapp,
        claimant_address: c.address,
      })),
    ];

    const respondent_Details = [
      {
        respondent_name: values.respondentName,
        respondent_email: values.respondentEmail,
        respondent_mobile_number: values.respondentPhone,
        respondent_whatsapp: values.respondentWhatsapp,
        respondent_address: values.respondentAddress,
      },
      ...values.additionalRespondents.map((r) => ({
        respondent_name: r.name,
        respondent_email: r.email,
        respondent_mobile_number: r.phone,
        respondent_whatsapp: r.whatsapp,
        respondent_address: r.address,
      })),
    ];

   const body = {
  claimant_Details,
  respondent_Details,
  arbitrator_Details,
  arbitration_petition: uploadedFiles,
  nature_of_Despute: values.natureOfDispute,
  value_of_Claim: values.valueOfClaim || "0",
};

    console.log("Final API Body:", body);

    await addCommenceArbitration(body);

    setPreviewOpen(false);

    await fetchArbitrationDetail();

  } catch (error) {
    console.log("Submit Error:", error);
  }
};

  const handleUpdate = () => {
    console.log("Arbitration update clicked.");
  };

  const handleAddArbitration = () => {
    setOperation("Add");
    setPreviewOpen(true);
  };

  const handleClose = async () => {
    setPreviewOpen(false);
  };


const columns = React.useMemo(() => {

  if (
  arbitrationType === "Scheduled Arbitration" ||
  arbitrationType === "Expired Arbitration"
) {
  return [
    {
      Header: "S.No",
      id: "serial",
      Cell: ({ row }) => (page - 1) * limit + row.index + 1,
    },
{
  Header: "Case ID",
  accessor: "cd_Case_ID",
  Cell: ({ value }) => (
    <span
      style={{ color: "red", cursor: "pointer" }} // make it obvious
      onClick={(e) => {
        e.stopPropagation();
        console.log("CLICK WORKING:", value);
        handleRowClick(value);
      }}
    >
      {value}
    </span>
  ),
},
    {
      Header: "Case Title",
      accessor: "case_title",
    },
    {
      Header: "VC Room",
      accessor: "vc_room_number",
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: ({ value }) =>
        value ? new Date(value).toLocaleDateString("en-IN") : "-",
    },
    {
      Header: "Time",
      accessor: "time",
      Cell: ({ value }) =>
        value ? new Date(value).toLocaleTimeString("en-IN") : "-",
    },
    {
      Header: "Status",
      id: "schedule_status",
      Cell: () =>
        arbitrationType === "Expired Arbitration" ? (
          <span className="text-red-600 font-medium">Expired</span>
        ) : (
          <span className="text-yellow-600 font-medium">Scheduled</span>
        ),
    },
  ];
}


  // DEFAULT = All Arbitration
  return [
    {
      Header: "S.No",
      id: "serial",
      Cell: ({ row }) => (page - 1) * limit + row.index + 1,
    },
    {
  Header: "Case ID",
  accessor: "cd_Case_ID",
  Cell: ({ value }) => (
    <span
      style={{ color: "red", cursor: "pointer" }} // make it obvious
      onClick={(e) => {
        e.stopPropagation();
        console.log("CLICK WORKING:", value);
        handleRowClick(value);
      }}
    >
      {value}
    </span>
  ),
},
    {
      Header: "Claimant Name",
      id: "claimant_name",
      Cell: ({ row }) =>
        row.original?.claimant_Details?.[0]?.claimant_name || "-",
    },
    {
      Header: "Claimant Email",
      id: "claimant_email",
      Cell: ({ row }) =>
        row.original?.claimant_Details?.[0]?.claimant_email || "-",
    },
    {
      Header: "Status",
      accessor: "isActive",
      Cell: ({ value }) =>
        value ? (
          <span className="text-green-600 font-medium text-sm">Active</span>
        ) : (
          <span className="text-red-600 font-medium">Inactive</span>
        ),
    },
  ];

}, [arbitrationType, page]);



  const data = React.useMemo(() => userData || [], [userData]);


  return (
    <>
   <div className="flex min-h-screen bg-gray-100">
  <div className="flex-1 w-full lg:ml-64 mt-16 lg:mt-20 px-4 sm:px-6 lg:px-8">

    {/* Header */}
    <div className="flex flex-col mt-16 md:mt-14 lg:flex-row lg:items-center lg:justify-between gap-4">
      <h1 className="text-2xl font-semibold text-gray-800">
        Arbitration Management
      </h1>
    </div>

    {/* Filters */}
    <div className="mt-6 flex flex-col md:flex-row gap-4">

      <select
        onChange={(e) => handleOption(e.target.value)}
        className="w-full md:w-60 border border-gray-300 rounded-lg px-3 py-2 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="all">All Arbitration</option>
        <option value="scheduled">Scheduled Arbitration</option>
        <option value="expired">Expired Arbitration</option>
      </select>

      <div className="w-full md:flex-1">
        <SearchBar
          placeholder="Search by Case ID"
          searchValue={searchQuery}
          setSearchValue={setSearchQuery}
          handleSearch={handleSearch}
        />
      </div>
    </div>


{/* for commence button */}

    {/* Button */}
    {/* <div className="mt-6">
      <Button1
        onClick={handleAddArbitration}
        label="Commence Arbitration +"
      />
    </div> */}


    {/* Table Section */}
    <div className="mt-8 bg-white rounded-xl shadow-sm border border-gray-200 p-4">

      <div className="text-lg font-semibold text-gray-700 mb-4">
        {arbitrationType}
      </div>

      {isLoading && (
        <div className="flex justify-center py-10">
          <Loader />
        </div>
      )}

      {showDetails ? (
        <>
          <div className="overflow-x-auto rounded-lg border border-gray-200">
            <Table columns={columns} data={data} />
          </div>

          <div className="mt-6 flex justify-end">
<Pagination
  page={page}
  totalPages={pagination.totalPages}
  hasPrevPage={page > 1}
  hasNextPage={page < pagination.totalPages}
  goToPrevPage={() => setPage((p) => Math.max(p - 1, 1))}
  goToNextPage={() =>
    setPage((p) => Math.min(p + 1, pagination.totalPages))
  }
/>
          </div>
        </>
      ) : (
        <EmptyDataAlert title="No Data Found" />
      )}

    </div>

  </div>
</div>

      {isPreviewOpen && (
        <ArbitrationAction
          isPreviewOpen={isPreviewOpen}
          onClose={() => setPreviewOpen(false)}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
          handleUpdate={handleUpdate}
          // formData={formData}
          // roleName={roleName}
          // isLoadingUpdate={isLoadingUpdate}
          // userId={userId}
          operation={operation}
        />
      )}
    </>
  );
};

export default ArbitrationTable;
